/**
 * /admin/preferences/ — index route.
 *
 * Redirects immediately to /preferences/interface (the default active section).
 * beforeLoad redirect is the cleanest approach for TanStack Router file-based routing.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/preferences/')({
  beforeLoad: () => {
    throw redirect({ to: '/preferences/interface' });
  },
  component: () => null,
});
